import { useEffect, useCallback } from 'react';
import { useLocation } from 'wouter';
import {
  registerDeepLinkHandler,
  mapDeepLinkToRoute,
  type DeepLinkRoute,
} from '../services/deepLinking';

/**
 * Deep Linking Hook
 *
 * Handles deep link navigation within the app.
 * Automatically navigates to the appropriate route when a deep link is received.
 */

export function useDeepLinking(): void {
  const [, setLocation] = useLocation();

  const handleDeepLink = useCallback(
    (route: DeepLinkRoute) => {
      // Map the deep link to an app route
      const appRoute = mapDeepLinkToRoute(route);

      // Navigate to the route
      setLocation(appRoute);
    },
    [setLocation]
  );

  useEffect(() => {
    // Register the handler and get cleanup function
    const cleanup = registerDeepLinkHandler(handleDeepLink);

    return cleanup;
  }, [handleDeepLink]);
}

export default useDeepLinking;
